import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { merge } from 'lodash';
import { defaultVariant } from '@utils/recordHelpers';

import { PolarisFormProvider } from '@container';

import VariantForm from '@presentational/product/VariantForm';

import axiosRails from '@utils/axios';

const propTypes = {
  variant: PropTypes.object.isRequired,
  update: PropTypes.bool,
  submitURL: PropTypes.string.isRequired,
  baseVariantsURL: PropTypes.string.isRequired,
  newURL: PropTypes.string,
  auditTrailURL: PropTypes.string,
};

const defaultProps = {
  update: false,
}

class VariantFormWrapper extends Component {
  constructor(props) {
    super(props);
    this.state= {
      //...defaultValues // When using polaris instead of formik
      defaultValues: props.update ? props.variant : merge(props.variant, defaultVariant),
      method: props.update ? "PATCH" : "POST",
    }
  }

  render() {
    let { defaultValues, method } = this.state;
    const { submitURL, weightUnits, variants, baseVariantsURL, backURL, product, productOptions, isAdmin } = this.props;
    const primaryAction = this.props.newURL ? { content: 'Agregar nueva Variación', url: this.props.newURL } : null
    const secondaryActions = this.props.auditTrailURL ? [{ content: I18n.t("app.audit_trail"), url: this.props.auditTrailURL, external: true }] : [];
    return (
      <PolarisFormProvider
        title={ this.props.title }
        defaultValues={ defaultValues }
        submitURL={ submitURL }
        submitMethod={ method }
        paramsName="variant"
        pageProps={{
          breadcrumbs: [{content: I18n.t("actions.back"), url: backURL }],
          primaryAction: primaryAction,
          secondaryActions: secondaryActions,
        }}
      >
      { (renderProps) =>
        <div>
          <hr/>
          <VariantForm 
            variants={ variants }
            weightUnits={ weightUnits }
            baseVariantsURL={ baseVariantsURL }
            product={product}
            productOptions={ productOptions }
            update={ this.props.update }
            handleDelete={ this.handleDelete }
            isAdmin={ isAdmin }
            {...renderProps} />
        </div>
      }
      </PolarisFormProvider>
    );
  }

  handleDelete = async () => {
    try {
      const response = await axiosRails.delete(this.props.submitURL);
      const { data } = response;
      if(data.success){
        window.location = data.redirectURL;
      }
      else{
        alert("An error ocurred with the request, try again later");
        console.log(data);
      }
    } catch (error) {
      alert("An error ocurred.")
    }
  }
}


VariantFormWrapper.propTypes = propTypes;
VariantFormWrapper.defaultProps = defaultProps;


export default VariantFormWrapper;
